import { createSelector } from 'reselect';
import { initialState } from './reducer';

const selectQuotations = state => state.get('quotations', initialState);

const makeSelectQuotations = () =>
  createSelector(selectQuotations, quotesState =>
    quotesState.getIn(['quotations']),
  );

const makeSelectQuotationsNumber = () =>
  createSelector(selectQuotations, quotesState => quotesState.get('total'));

const makeSelectQuotationsParameters = () =>
  createSelector(selectQuotations, quotesState =>
    quotesState.get('parameters').toJS(),
  );

const makeSelectQuotationsRequest = () =>
  createSelector(selectQuotations, quotationsState => ({
    parameters: quotationsState.get('parameters').toJS(),
    order: quotationsState.get('selectedOrder'),
    page: quotationsState.get('currentPage'),
    items: quotationsState.get('itemsPerPage'),
  }));

const makeSelectQuotationsSort = () =>
  createSelector(selectQuotations, selectedState =>
    selectedState.get('orders').toArray(),
  );

const makeSelectQuotationsFilters = () =>
  createSelector(selectQuotations, selectedState =>
    selectedState.get('filters'),
  );

const makeSelectSelectedQuotationsSort = () =>
  createSelector(selectQuotations, selectedState =>
    selectedState.get('selectedOrder'),
  );

const makeSelectPaginator = () =>
  createSelector(selectQuotations, selectedState => ({
    total: selectedState.get('total'),
    lastPage: selectedState.get('lastPage'),
    itemsPerPage: selectedState.get('itemsPerPage'),
    currentPage: selectedState.get('currentPage'),
  }));

const makeSelectLoading = () =>
  createSelector(selectQuotations, quotesState => quotesState.get('loading'));

export {
  selectQuotations,
  makeSelectQuotations,
  makeSelectQuotationsRequest,
  makeSelectQuotationsNumber,
  makeSelectQuotationsSort,
  makeSelectQuotationsFilters,
  makeSelectSelectedQuotationsSort,
  makeSelectQuotationsParameters,
  makeSelectPaginator,
  makeSelectLoading,
};
